import { render, staticRenderFns } from "./ModalMilimetragem.vue?vue&type=template&id=9079f3c6&"
import script from "./ModalMilimetragem.vue?vue&type=script&lang=js&"
export * from "./ModalMilimetragem.vue?vue&type=script&lang=js&"
import style0 from "./style.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports